import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function WhatsAppFloat() {
  const {
    language
  } = useLanguage();
  const message = language === 'es' ? 'Hola Lorena, me gustaría agendar una cita.' : 'Hi Lorena, I would like to book an appointment.';
  const href = `https://wa.me/13472648498?text=${encodeURIComponent(message)}`;
  const label = language === 'es' ? 'Contáctanos por WhatsApp' : 'Contact us on WhatsApp';
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} initial={{
    opacity: 0,
    scale: 0.6,
    y: 20
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    delay: 1,
    duration: 0.5,
    type: 'spring',
    stiffness: 200
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-lg shadow-black/20 hover:shadow-xl transition-shadow" data-id="element-447">
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" data-id="element-448" />
      <svg viewBox="0 0 32 32" className="relative w-7 h-7 md:w-8 md:h-8 text-white" fill="currentColor" aria-hidden="true" data-id="element-449">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 01-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 01-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.04 2.264v.114c-.005.628.196 1.24.45 1.804.832 1.84 2.323 3.434 4.094 4.353.444.23.973.434 1.484.567.522.137 1.04.137 1.564.137h.045c.66 0 1.62-.358 2.155-.967.18-.205.348-.435.397-.7.05-.264.083-.515.083-.756 0-.157-.014-.275-.072-.36-.158-.275-.357-.4-.602-.515-.224-.115-.575-.214-.962-.214zM16.001 0C7.165 0 0 7.165 0 16c0 2.85.745 5.524 2.051 7.84L0 32l8.405-2.013A15.929 15.929 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16.001 0zm0 29.252c-2.504 0-4.836-.749-6.781-2.034l-.486-.288-5.026 1.203 1.234-4.9-.317-.504a13.214 13.214 0 01-2.06-7.077c0-7.337 5.97-13.307 13.307-13.307 7.336 0 13.306 5.97 13.306 13.307s-5.97 13.6-13.177 13.6z" data-id="element-450" />
      </svg>
    </motion.a>;
}